import { Box, Text } from '@bfa/common-ui';
import React from 'react';
import PostSection from './PostSection';
import SocialMediaIcons from './SocialMediaIcons';
var SocialMediaSection = function (_a) {
    var content = _a.content, posts = _a.posts;
    return (React.createElement(Box, { margin: "3rem 1.5rem" },
        React.createElement(Text, { fontSize: ['2.4rem', '3.6rem'], lineHeight: "3.6rem", letterSpacing: "0.02rem", bold: true, textAlign: "center" }, content === null || content === void 0 ? void 0 : content.socialMediaTitle),
        React.createElement(SocialMediaIcons, { content: content }),
        React.createElement(PostSection, { posts: posts !== null && posts !== void 0 ? posts : [] })));
};
export default SocialMediaSection;
